"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = postSearch;
const client_1 = __importDefault(require("../../client/client"));
async function postSearch(config, options, pageParam) {
    // Prepare the request body
    const requestBody = {
        query: options.q,
        types: options.types,
        authors: (options === null || options === void 0 ? void 0 : options.authors) ? [options === null || options === void 0 ? void 0 : options.authors] : undefined,
        categories: (options === null || options === void 0 ? void 0 : options.categories) ? [options === null || options === void 0 ? void 0 : options.categories] : undefined,
        orderBy: options.orderBy || 0,
        to: options.to,
        from: options.from,
        platform: "headless",
    };
    return client_1.default.post(config["API_URL"], `/search?start=${pageParam}`, requestBody);
}
